<template>
	<div class="swiper-container swiper-container-down">
		<div class="swiper-wrapper">
			<div class="swiper-slide" @click="toDetail(item)" v-for="item in list" :key="item.id">
				<ul class="document-list">
					<li>
						<h3  class="list-title">{{item.linkName}}</h3>
						<div class="list-desc">
							{{item.content}}
						</div>
						<div class="list-tips">
							<span>下载次数：{{item.orderNum}}</span>
							<span>{{item.addTime | datefmt('yyyy-MM-DD')}}</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="swiper-pagination"></div>
	</div>
</template>

<script>
	export default {
		name: 'DownHome',
		props: {
			list: {
				type: Array,
				value: []
			}
		},
		created(){
			setTimeout(res=>{
				this.initSwiper()
			},300)
		},
		methods: {
			initSwiper(){
				new Swiper(".swiper-container-down", {
					autoplay: false,
					// 轮播效果,默认为平滑轮播
					effect: "slide",
					pagination: '.swiper-pagination',
					paginationClickable :true,
					slidesPerView: 2,
					slidesPerGroup: 2
				})
			},
			toDetail(item){
				this.$emit('toDetail', {
					id: item.id
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.document-list{
		display: flex;
		padding-bottom: 30px;
		li{
			width: 580px;
			height: 182px;
			background: #fff;
			padding: 20px 24px;
			margin-bottom: 20px;
			margin-right: 20px;
			border-radius: 5px;
			box-sizing: border-box;
			overflow: hidden;
			cursor: pointer;
			h3{
				width: 533px;
				height: 48px;
				font-weight: 500;
				font-size: 18px;
				color: #37383c;
				letter-spacing: 1.29px;
				line-height: 24px;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				overflow: hidden;
				-webkit-box-orient: vertical;
			}
			.list-desc{
				width: 533px;
				height: 48px;
				margin: 8px 0 16px;
				font-weight: 400;
				font-size: 14px;
				color: #37383c;
				line-height: 24px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}
			.list-tips{
				height: 20px;
				margin: 8px 0 12px;
				font-size: 14px;
				letter-spacing: 1px;
				line-height: 20px;
				span{
					padding-right: 20px
				}
			}
		}
		li:hover{
			box-shadow: 0 6px 11px 0 rgba(75,121,189,.2);
		}
	}
</style>
